let ingredientsToggles = {
  init() {
    this.ingredientsToggles = document.querySelectorAll('.ingredients-toggles .ingredients-toggle input');
    this.ingredientsTables = document.querySelectorAll('.ingredients-tables table');

    if (this.ingredientsToggles && this.ingredientsTables) {
      for (const ingredientsToggle of this.ingredientsToggles) {
        ingredientsToggle.addEventListener('change', (e) => {
          let selectedIngredientsToggle = e.target;
          let selectedProductId = selectedIngredientsToggle.id;

          for (const ingredientsTable of this.ingredientsTables) {
            ingredientsTable.classList.toggle(
              'hide',
              !(ingredientsTable.id == `table_${selectedProductId}`)
            );
          }
        });
      }
    }
  },
};

document.addEventListener('DOMContentLoaded', (e) => {
  ingredientsToggles.init();
});